import type { IconButtonProjection } from '@lib/sanity/types/common';
import Visuals from '@ui/Visuals/Visuals';
import cn from '@utils/cn';
import { getIconVisual } from '@utils/getIconVisual';
import { isButtonExist } from '@utils/validations';
import { VariantProps } from 'class-variance-authority';
import Anchor from '../Anchor/Anchor';
import { Button, buttonVariants } from '../Button/Button';

export type IconButtonProps = {
  button?: IconButtonProjection;
  variant?: VariantProps<typeof buttonVariants>['variant'];
  size?: 'icon' | 'link' | VariantProps<typeof buttonVariants>['size'];
  className?: string;
};

export default function IconButton({ button, variant, size = 'xl', className }: IconButtonProps) {
  if (!isButtonExist(button)) {
    return null;
  }

  const iconVisuals = getIconVisual(button.icon);

  return (
    <Button className={className} variant={variant} size={size} asChild type="button">
      <Anchor
        aria-label={button.text?.value ?? ''}
        href={button.url || undefined}
        className={cn('flex flex-row gap-2 ', {
          'flex-row-reverse': button.align === 'right',
        })}
      >
        <Visuals
          data={iconVisuals}
          className={cn('h-6 w-6 object-contain', {
            'h-4 w-4 md:h-4 md:w-4': size === 'xs',
          })}
        />
        {button.text?.value}
      </Anchor>
    </Button>
  );
}
